/**
 * 展立组合键（demo KeyTabs 组合键 Tab：type=128/0x80）
 */

/** demo keys.json / 协议：组合键与预设快捷键均为 type 128 */
export const ZHANLI_T_COMBO = 128;

const KC = {
  KC_1: 0x001e,
  KC_2: 0x001f,
  KC_3: 0x0020,
  KC_4: 0x0021,
  KC_5: 0x0022,
  KC_6: 0x0023,
  KC_7: 0x0024,
  KC_8: 0x0025,
  KC_9: 0x0026,
  KC_0: 0x0027,
  KC_A: 0x0004,
  KC_B: 0x0005,
  KC_C: 0x0006,
  KC_D: 0x0007,
  KC_E: 0x0008,
  KC_F: 0x0009,
  KC_G: 0x000a,
  KC_H: 0x000b,
  KC_I: 0x000c,
  KC_J: 0x000d,
  KC_K: 0x000e,
  KC_L: 0x000f,
  KC_M: 0x0010,
  KC_N: 0x0011,
  KC_O: 0x0012,
  KC_P: 0x0013,
  KC_Q: 0x0014,
  KC_R: 0x0015,
  KC_S: 0x0016,
  KC_T: 0x0017,
  KC_U: 0x0018,
  KC_V: 0x0019,
  KC_W: 0x001a,
  KC_X: 0x001b,
  KC_Y: 0x001c,
  KC_Z: 0x001d,
  KC_COMM: 0x0036,
  KC_DOT: 0x0037,
  KC_SCLN: 0x0033,
  KC_QUOT: 0x0034,
  KC_LBRC: 0x002f,
  KC_RBRC: 0x0030,
  KC_BSPC: 0x002a,
  KC_GRV: 0x0035,
  KC_SLSH: 0x0038,
  KC_BSLS: 0x0031,
  KC_MINS: 0x002d,
  KC_EQL: 0x002e,
  KC_RO: 0x0087,
  KC_JYEN: 0x0089,
  KC_LALT: 0x00e2,
  KC_RALT: 0x00e6,
  KC_CAPS: 0x0039,
  KC_LCTL: 0x00e0,
  KC_RCTL: 0x00e4,
  KC_LGUI: 0x00e3,
  KC_RGUI: 0x00e7,
  KC_LSFT: 0x00e1,
  KC_RSFT: 0x00e5,
  KC_APP: 0x0065,
  KC_ENT: 0x0028,
  KC_SPC: 0x002c,
  KC_TAB: 0x002b,
  KC_DEL: 0x004c,
  KC_END: 0x004d,
  KC_HELP: 0x0075,
  KC_HOME: 0x004a,
  KC_INS: 0x0049,
  KC_PGDN: 0x004e,
  KC_PGUP: 0x004b,
  KC_DOWN: 0x0051,
  KC_LEFT: 0x0050,
  KC_RGHT: 0x004f,
  KC_UP: 0x0052,
  KC_ESC: 0x0029,
  KC_PSCR: 0x0046,
  KC_SLCK: 0x0047,
  KC_VOLU: 0x00a9,
  KC_VOLD: 0x00aa,
  KC_MUTE: 0x00a8,
  KC_PAUS: 0x0048,
  KC_F1: 0x003a,
  KC_F2: 0x003b,
  KC_F3: 0x003c,
  KC_F4: 0x003d,
  KC_F5: 0x003e,
  KC_F6: 0x003f,
  KC_F7: 0x0040,
  KC_F8: 0x0041,
  KC_F9: 0x0042,
  KC_F10: 0x0043,
  KC_F11: 0x0044,
  KC_F12: 0x0045,
  KC_F13: 0x0068,
  KC_F14: 0x0069,
  KC_F15: 0x006a,
  KC_F16: 0x006b,
  KC_F17: 0x006c,
  KC_F18: 0x006d,
  KC_F19: 0x006e,
  KC_F20: 0x006f,
  KC_F21: 0x0070,
  KC_F22: 0x0071,
  KC_F23: 0x0072,
  KC_F24: 0x0073,
  KC_NLCK: 0x0053,
  KC_P0: 0x0062,
  KC_P1: 0x0059,
  KC_P2: 0x005a,
  KC_P3: 0x005b,
  KC_P4: 0x005c,
  KC_P5: 0x005d,
  KC_P6: 0x005e,
  KC_P7: 0x005f,
  KC_P8: 0x0060,
  KC_P9: 0x0061,
  KC_PPLS: 0x0057,
  KC_PDOT: 0x0063,
  KC_PSLS: 0x0054,
  KC_PENT: 0x0058,
  KC_PEQL: 0x0067,
  KC_PAST: 0x0055,
  KC_PMNS: 0x0056,
} as const;

/** 与 demo libs/keycode.evtToKeyByte 一致 */
const EVT_TO_KEY_BYTE: Record<string, number> = {
  Digit1: KC.KC_1,
  Digit2: KC.KC_2,
  Digit3: KC.KC_3,
  Digit4: KC.KC_4,
  Digit5: KC.KC_5,
  Digit6: KC.KC_6,
  Digit7: KC.KC_7,
  Digit8: KC.KC_8,
  Digit9: KC.KC_9,
  Digit0: KC.KC_0,
  KeyA: KC.KC_A,
  KeyB: KC.KC_B,
  KeyC: KC.KC_C,
  KeyD: KC.KC_D,
  KeyE: KC.KC_E,
  KeyF: KC.KC_F,
  KeyG: KC.KC_G,
  KeyH: KC.KC_H,
  KeyI: KC.KC_I,
  KeyJ: KC.KC_J,
  KeyK: KC.KC_K,
  KeyL: KC.KC_L,
  KeyM: KC.KC_M,
  KeyN: KC.KC_N,
  KeyO: KC.KC_O,
  KeyP: KC.KC_P,
  KeyQ: KC.KC_Q,
  KeyR: KC.KC_R,
  KeyS: KC.KC_S,
  KeyT: KC.KC_T,
  KeyU: KC.KC_U,
  KeyV: KC.KC_V,
  KeyW: KC.KC_W,
  KeyX: KC.KC_X,
  KeyY: KC.KC_Y,
  KeyZ: KC.KC_Z,
  Comma: KC.KC_COMM,
  Period: KC.KC_DOT,
  Semicolon: KC.KC_SCLN,
  Quote: KC.KC_QUOT,
  BracketLeft: KC.KC_LBRC,
  BracketRight: KC.KC_RBRC,
  Backspace: KC.KC_BSPC,
  Backquote: KC.KC_GRV,
  Slash: KC.KC_SLSH,
  Backslash: KC.KC_BSLS,
  Minus: KC.KC_MINS,
  Equal: KC.KC_EQL,
  IntlRo: KC.KC_RO,
  IntlYen: KC.KC_JYEN,
  AltLeft: KC.KC_LALT,
  AltRight: KC.KC_RALT,
  CapsLock: KC.KC_CAPS,
  ControlLeft: KC.KC_LCTL,
  ControlRight: KC.KC_RCTL,
  MetaLeft: KC.KC_LGUI,
  MetaRight: KC.KC_RGUI,
  OSLeft: KC.KC_LGUI,
  OSRight: KC.KC_RGUI,
  ShiftLeft: KC.KC_LSFT,
  ShiftRight: KC.KC_RSFT,
  ContextMenu: KC.KC_APP,
  Enter: KC.KC_ENT,
  Space: KC.KC_SPC,
  Tab: KC.KC_TAB,
  Delete: KC.KC_DEL,
  End: KC.KC_END,
  Help: KC.KC_HELP,
  Home: KC.KC_HOME,
  Insert: KC.KC_INS,
  PageDown: KC.KC_PGDN,
  PageUp: KC.KC_PGUP,
  ArrowDown: KC.KC_DOWN,
  ArrowLeft: KC.KC_LEFT,
  ArrowRight: KC.KC_RGHT,
  ArrowUp: KC.KC_UP,
  Escape: KC.KC_ESC,
  PrintScreen: KC.KC_PSCR,
  ScrollLock: KC.KC_SLCK,
  AudioVolumeUp: KC.KC_VOLU,
  AudioVolumeDown: KC.KC_VOLD,
  AudioVolumeMute: KC.KC_MUTE,
  Pause: KC.KC_PAUS,
  F1: KC.KC_F1,
  F2: KC.KC_F2,
  F3: KC.KC_F3,
  F4: KC.KC_F4,
  F5: KC.KC_F5,
  F6: KC.KC_F6,
  F7: KC.KC_F7,
  F8: KC.KC_F8,
  F9: KC.KC_F9,
  F10: KC.KC_F10,
  F11: KC.KC_F11,
  F12: KC.KC_F12,
  F13: KC.KC_F13,
  F14: KC.KC_F14,
  F15: KC.KC_F15,
  F16: KC.KC_F16,
  F17: KC.KC_F17,
  F18: KC.KC_F18,
  F19: KC.KC_F19,
  F20: KC.KC_F20,
  F21: KC.KC_F21,
  F22: KC.KC_F22,
  F23: KC.KC_F23,
  F24: KC.KC_F24,
  NumLock: KC.KC_NLCK,
  Numpad0: KC.KC_P0,
  Numpad1: KC.KC_P1,
  Numpad2: KC.KC_P2,
  Numpad3: KC.KC_P3,
  Numpad4: KC.KC_P4,
  Numpad5: KC.KC_P5,
  Numpad6: KC.KC_P6,
  Numpad7: KC.KC_P7,
  Numpad8: KC.KC_P8,
  Numpad9: KC.KC_P9,
  NumpadAdd: KC.KC_PPLS,
  NumpadComma: KC.KC_COMM,
  NumpadDecimal: KC.KC_PDOT,
  NumpadDivide: KC.KC_PSLS,
  NumpadEnter: KC.KC_PENT,
  NumpadEqual: KC.KC_PEQL,
  NumpadMultiply: KC.KC_PAST,
  NumpadSubtract: KC.KC_PMNS,
};

const KEY_BYTE_TO_NAME: Record<number, string> = {
  [KC.KC_A]: "A",
  [KC.KC_B]: "B",
  [KC.KC_C]: "C",
  [KC.KC_D]: "D",
  [KC.KC_E]: "E",
  [KC.KC_F]: "F",
  [KC.KC_G]: "G",
  [KC.KC_H]: "H",
  [KC.KC_I]: "I",
  [KC.KC_J]: "J",
  [KC.KC_K]: "K",
  [KC.KC_L]: "L",
  [KC.KC_M]: "M",
  [KC.KC_N]: "N",
  [KC.KC_O]: "O",
  [KC.KC_P]: "P",
  [KC.KC_Q]: "Q",
  [KC.KC_R]: "R",
  [KC.KC_S]: "S",
  [KC.KC_T]: "T",
  [KC.KC_U]: "U",
  [KC.KC_V]: "V",
  [KC.KC_W]: "W",
  [KC.KC_X]: "X",
  [KC.KC_Y]: "Y",
  [KC.KC_Z]: "Z",
  [KC.KC_1]: "1",
  [KC.KC_2]: "2",
  [KC.KC_3]: "3",
  [KC.KC_4]: "4",
  [KC.KC_5]: "5",
  [KC.KC_6]: "6",
  [KC.KC_7]: "7",
  [KC.KC_8]: "8",
  [KC.KC_9]: "9",
  [KC.KC_0]: "0",
  [KC.KC_ENT]: "Enter",
  [KC.KC_ESC]: "Esc",
  [KC.KC_BSPC]: "Backspace",
  [KC.KC_TAB]: "Tab",
  [KC.KC_SPC]: "Space",
  [KC.KC_LEFT]: "Left",
  [KC.KC_DOWN]: "Down",
  [KC.KC_RGHT]: "Right",
  [KC.KC_UP]: "Up",
  [KC.KC_F1]: "F1",
  [KC.KC_F2]: "F2",
  [KC.KC_F3]: "F3",
  [KC.KC_F4]: "F4",
  [KC.KC_F5]: "F5",
  [KC.KC_F6]: "F6",
  [KC.KC_F7]: "F7",
  [KC.KC_F8]: "F8",
  [KC.KC_F9]: "F9",
  [KC.KC_F10]: "F10",
  [KC.KC_F11]: "F11",
  [KC.KC_F12]: "F12",
};

export type ZhanliComboModifiers = {
  ctrl: boolean;
  shift: boolean;
  alt: boolean;
  win: boolean;
};

/** demo KeyTabs：code1 位掩码 */
export function encodeZhanliComboCode1(mods: ZhanliComboModifiers): number {
  return (
    (mods.ctrl ? 1 : 0) |
    (mods.shift ? 1 << 1 : 0) |
    (mods.alt ? 1 << 2 : 0) |
    (mods.win ? 1 << 3 : 0)
  );
}

export function decodeZhanliComboCode1(code1: number): ZhanliComboModifiers {
  // 仅低 4 bit 为修饰掩码；高位垃圾（如 0xFF）不得点亮全部修饰键
  const c = code1 & 0x0f;
  return {
    ctrl: !!(c & 1),
    shift: !!((c >> 1) & 1),
    alt: !!((c >> 2) & 1),
    win: !!((c >> 3) & 1),
  };
}

/** KeyboardEvent.code → demo HID usage（与 demo eventCode2Keycode 一致） */
export function zhanliEventCodeToKeyByte(code: string): number | undefined {
  return EVT_TO_KEY_BYTE[code];
}

export function zhanliKeyByteToDisplayName(code2: number): string {
  const n = code2 & 0xff;
  if (!n || isZhanliModifierKeyByte(n)) return "";
  // 与匠盟空快捷键一致：未收录的码不回显 Key(n)，交由上层显示「未设置」
  return KEY_BYTE_TO_NAME[n] ?? "";
}

/** 展示名 → HID usage（用于 ShortcutKey 字符串回显还原） */
export function zhanliDisplayNameToKeyByte(name: string): number | undefined {
  const target = name.trim().toUpperCase();
  if (!target) return undefined;
  for (const [byte, label] of Object.entries(KEY_BYTE_TO_NAME)) {
    if (String(label).toUpperCase() === target) return Number(byte);
  }
  return undefined;
}

/** HID 修饰键 usage（不可作为组合键主键） */
export function isZhanliModifierKeyByte(code: number): boolean {
  const n = code & 0xff;
  return n >= 0xe0 && n <= 0xe7;
}

export function formatZhanliComboLabel(code1: number, code2: number): string {
  // 与 keymap canonicalize 对齐：无主键时若 code1 像 HID，按单键展示
  let modsByte = code1 & 0xff;
  let keyByte = code2 & 0xff;
  if (keyByte === 0 && modsByte >= 4 && modsByte < 0xe0) {
    keyByte = modsByte;
    modsByte = 0;
  } else if (modsByte > 0x0f && keyByte >= 4 && keyByte < 0xe0) {
    modsByte = 0;
  } else {
    modsByte &= 0x0f;
  }
  const keyName = zhanliKeyByteToDisplayName(keyByte);
  if (!keyName) return "";
  const mods = decodeZhanliComboCode1(modsByte);
  const parts: string[] = [];
  if (mods.ctrl) parts.push("Ctrl");
  if (mods.shift) parts.push("Shift");
  if (mods.alt) parts.push("Alt");
  if (mods.win) parts.push("Win");
  parts.push(keyName);
  return parts.join("+");
}

export function buildZhanliComboStoreValue(
  code1: number,
  code2: number,
  code3 = 0
): string {
  let mods = code1 & 0xff;
  let main = code2 & 0xff;
  if (main === 0 && mods >= 4 && mods < 0xe0) {
    main = mods;
    mods = 0;
  } else if (mods > 0x0f && main >= 4 && main < 0xe0) {
    mods = 0;
  } else {
    mods &= 0x0f;
  }
  return ["zhanli", ZHANLI_T_COMBO, mods, main, code3 & 0xff].join(",");
}

export function parseZhanliComboStoreValue(
  value: string | null | undefined
): { code1: number; code2: number; code3: number } | null {
  if (!value) return null;
  const parts = value.split(",").map((s) => s.trim());
  if (parts[0]?.toLowerCase() !== "zhanli" || parts.length < 5) return null;
  const type = Number(parts[1]);
  if (type !== ZHANLI_T_COMBO) return null;
  let code1 = Number(parts[2]);
  let code2 = Number(parts[3]);
  const code3 = Number(parts[4]);
  if (![code1, code2, code3].every((n) => Number.isFinite(n))) return null;
  code1 &= 0xff;
  code2 &= 0xff;
  // 与 keymap canonicalize 一致，避免脏 code1 点亮全部修饰键
  if (code2 === 0 && code1 >= 4 && code1 < 0xe0) {
    return { code1: 0, code2: code1, code3: code3 & 0xff };
  }
  if (code1 > 0x0f && code2 >= 4 && code2 < 0xe0) {
    return { code1: 0, code2, code3: code3 & 0xff };
  }
  return { code1: code1 & 0x0f, code2, code3: code3 & 0xff };
}
